import { useContext, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { onSubmit } from ".";
import { ApiContext } from "../../context/ApiContext";
import endpoints from "../../data/endpoints";
import Button from "../../shared/Button";
import { FormInputs } from "../../types/types";
import __ from "../../utils/getContent";
import PasswordField from "../fields/passwordField";
import TextField from "../fields/textField";

const StepAdvisorLogin = (): React.JSX.Element => {
	const { handleSubmit, trigger, watch } = useFormContext<FormInputs>();
	const { data, setData } = useContext(ApiContext);
	const [isLoading, setIsLoading] = useState(false);
	const [submitError, setSubmitError] = useState("");
	const navigate = useNavigate();

	const login = async () => {
		try {
			setIsLoading(true);

			const username = watch("advisor.username");
			const password = watch("advisor.password");

			const headers = {
				"Content-Type": "application/json",
				...(window?.midtownMembershipsVerify?.nonce_verification_enabled && {
					"X-WP-Nonce": window?.midtownMembershipsVerify?.nonce || "",
				}),
			};

			const response = await fetch(endpoints.advisorLogin.url, {
				method: endpoints.advisorLogin.requestMethod,
				headers,
				credentials: "same-origin",
				body: JSON.stringify({
					payload: btoa(
						JSON.stringify({
							Username: username,
							Password: password,
						}),
					),
				}),
			});

			const result = await response.json();

			if (
				result?.status === 200 &&
				result?.data?.CounselorInfo?.EmployeeAuthTicket
			) {
				const homeClub = result?.data?.CounselorInfo?.HomeClub;

				setData({
					...data,
					isLoggedIn: true,
					EmployeeAuthTicket: result?.data?.CounselorInfo?.EmployeeAuthTicket,
					advisorFirstName: result?.data?.CounselorInfo?.FirstName,
					get_club_id: homeClub?.ClubID,
					selectedClub: homeClub,
				});
				navigate("?step=pricing");
			} else {
				const message =
					result?.message?.Error ??
					"Invalid login name or password. Please try again.";
				setSubmitError(message);
			}

			setIsLoading(false);
		} catch (error) {
			console.error(error);
			setIsLoading(false);
			return "Advisor Login Failed";
		}
		setIsLoading(false);
	};

	return (
		<div className="mb-10 flex max-w-[600px] flex-col self-center">
			<div className="border border-black p-4">
				<form onSubmit={handleSubmit(onSubmit)} className="w-96">
					<h3 className="mb-5 border-b border-black py-3 text-lg font-bold uppercase">
						{__("advisor_login", "Advisor Login")}
					</h3>
					<TextField
						registeredName="advisor.username"
						label={__("input_username_label", "Username")}
						isRequired={true}
						requiredText={__("input_required", "This field is required.")}
					/>

					<PasswordField
						registeredName="advisor.password"
						label={__("input_password_label", "Password")}
						isRequired={true}
						requiredText={__("input_required", "This field is required.")}
					/>
					<Button
						action={async () => {
							const isValid = await trigger();
							if (isValid) login();
						}}
						isLoading={isLoading}
						buttonType="button"
					>
						{__("button_text_login", "Login")}
					</Button>

					{submitError && (
						<p className="validation-error mt-2 text-sm text-red-500">
							{submitError}
						</p>
					)}
				</form>
			</div>
		</div>
	);
};

export default StepAdvisorLogin;
